import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { theme } from "./utils/hooks/useTheme";
import { ToastProvider } from "./components/ui/toast";
// force deploy
const muiTheme = createTheme({
  palette: {
    primary: {
      main: theme.colors.primary,
    },
    secondary: {
      main: theme.colors.secondary,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <StyledThemeProvider theme={theme}>
        <ThemeProvider theme={muiTheme}>
          <Provider store={store}>
            <ToastProvider>
              <ToastContainer theme="light" position="top-center" limit={3} />
              <App />
            </ToastProvider>
          </Provider>
        </ThemeProvider>
      </StyledThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
